const links = {
  twitter: "https://twitter.com",
  linkedin: "https://www.linkedin.com/company/new-form-capital/",
  email: "mailto:info@newformcap.com",
}

export default links
